export const sortCtas = (ctas) => {
    return ctas.sort((a, b) => {
        if(a && b && a.Title && b.Title){
        return b.Title > a.Title ? -1 : 1;
        }
        return 0;
    });
};

export const sortCategoryContent = (categoryContents) => {
    if (!categoryContents) return [];
    return categoryContents.sort((a, b) => {
        if(a && b && a.Category && b.Category && b.Category.Title && a.Category.Title){
        return b.Category.Title > a.Category.Title ? -1 : 1;
        }
        return 0;
    });
};

export const sortingbySortorderInServiceBrand = (ctas) => {
    if (!ctas) return [];
    return ctas.sort((a, b) => {
        if (a && b && a.SortOrder && b.SortOrder) {
            return parseInt(b.SortOrder) > parseInt(a.SortOrder) ? -1 : 1;
        }
        return 0;
    });
};

export const sortingbySortorder = (ctas) => {
    if (!ctas) return [];
    return ctas.sort((a, b) => {
        if (a && b && a.Category && b.Category && a.Category.SortOrder && b.Category.SortOrder) {
            return parseInt(b.Category.SortOrder) > parseInt(a.Category.SortOrder) ? -1 : 1;
        }
        return 0;
    });
};
